const initialState = {
    multipleChoiceContents: [],
    openEndedAnswers : [],
    isSecretCode: false,
    assessmentType: 0,
    assessmentTypeName: '',
    interactiveContentId: '',
    traitGroupId: '',
    secretCode: '',
    maxScore: 0,
};

const assessmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_MULTIPLECHOICE_CONTENTS':
            return { ...state, multipleChoiceContents: action.multipleChoiceContents };
        case 'SET_IS_SECRETCODE':
            return { ...state, isSecretCode: action.isSecretCode };
        case 'SET_MAXSCORE':
            return { ...state, maxScore: action.maxScore };
        case 'SET_TRAIT_GROUP_ID':
            return { ...state, traitGroupId: action.traitGroupId };
        case 'SET_INTERACTIVE_CONTENT_ID':
            return { ...state, interactiveContentId: action.interactiveContentId };
        case 'SET_SECRET_CODE':
            return { ...state, secretCode: action.secretCode };
        case 'SET_ASSESSMENT_TYPE':
            return { ...state, assessmentType: action.assessmentType };
        case 'SET_ASSESSMENT_TYPE_NAME':
            return { ...state, assessmentTypeName: action.assessmentTypeName };
        case 'SET_OPENENDED_ANSWERS':
            return {...state, openEndedAnswers: action.openEndedAnswers};
        default:
            return state;
    }
}

export { assessmentReducer as default }